import React from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import ContactAddressEdit from '@components/shared/contact_addresses/ContactAddressEdit';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import { contactAddressService } from '@services/operator/contactAddressService';

const OperatorContactAddressNewInner: React.FC = () => {
  const { merchantSalesChannels, currentMerchant } = useOperatorData();
  // MerchantSelect 已保證 currentMerchant 存在；narrow 後傳純 string，去除 dead `?? null`。
  if (!currentMerchant?.id) return null;
  return (
    <ContactAddressEdit
      contactAddressService={contactAddressService}
      role="operator"
      salesChannels={merchantSalesChannels}
      merchantId={currentMerchant.id}
    />
  );
};

const OperatorContactAddressNew: React.FC = () => {
  return (
    <MerchantSelect>
      <OperatorContactAddressNewInner />
    </MerchantSelect>
  );
};

export default OperatorContactAddressNew;
